import { IconButton, Typography } from "@mui/material";
import React, { Fragment } from "react";
import AnomalyIco from "../../../../assets/icons/AnomalyIco";
import CandidateFitIco from "../../../../assets/icons/CandidateFitIco";
import RedFlagIco from "../../../../assets/icons/RedFlagIco";
import RedFlagNegativeIco from "../../../../assets/icons/RedFlagNegativeIco";
import { ReactComponent as CandidateChatBot } from "../../../../assets/images/CandidateChatBot.svg";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CommonTippy } from "../../style";
import CommonButton from "../../../../component/Button";

export default function Result({
  loading,
  matchedData,
  handleQuestionMarkClick,
  iconVisible,
  chatBotData,
  handleReview,
  negative_flag,
  checkWidth,
}) {
  console.log("matchedData", matchedData);
  console.log("matchedData", matchedData?.resume_info?.candidate_name);
  return (
    <CommonGrid2
      display={"flex"}
      gap={"1rem"}
      alignItems={"start"}
      border={"1px solid #EAECF0"}
      borderRadius={"10px"}
      padding={"1rem"}
    >
      {loading ? (
        <HandleSkeletion
          width="50px"
          height="50px"
          marginRight={"1rem"}
          transform="scale(1)"
          borderRadius="50px"
        />
      ) : (
        <CustomDiv>
          <CandidateChatBot style={{ width: "50px", height: "50px" }} />
        </CustomDiv>
      )}
      <CommonGrid2
        display={"flex"}
        flexDirection={"column"}
        gap={"3px"}
        width={"100%"}
      >
        {loading ? (
          <HandleSkeletion width="300px" height="30px" transform="scale(1)" />
        ) : (
          <Typography variant="body3" fontWeight={600}>
            {`Here is my analysis of ${matchedData.name || matchedData?.resume_info?.candidate_name}`}
          </Typography>
        )}
        {loading ? (
          <HandleSkeletion height={50} width={"100px"} />
        ) : (
          <CommonGrid2 display={"flex"} gap={"10px"} alignItems={"center"}>
            <Typography variant="div" fontWeight={500}>
              {"Analysis Score"}
            </Typography>

            <Typography
              variant="subtitle1"
              border={
                matchedData?.resume_info?.candidate_fit?.fit === "Weak Fit"
                  ? "1px solid #ff0700"
                  : matchedData?.resume_info?.candidate_fit?.fit ===
                    "Strong Fit"
                  ? "none"
                  : "1px solid #ffa000"
              }
              backgroundColor={
                matchedData?.resume_info?.candidate_fit?.fit === "Weak Fit"
                  ? "#ff070026"
                  : matchedData?.resume_info?.candidate_fit?.fit ===
                    "Strong Fit"
                  ? "#079455"
                  : "#ffa6021c"
              }
              color={
                matchedData?.resume_info?.candidate_fit?.fit === "Weak Fit"
                  ? "#ff0700"
                  : matchedData?.resume_info?.candidate_fit?.fit ===
                    "Strong Fit"
                  ? "#fff"
                  : "#ff9000"
              }
              padding={"1px 10px"}
              borderRadius={"50px"}
              fontWeight={600}
            >
              {matchedData?.match_summary?.[0]?.score}% -{" "}
              {`${matchedData?.resume_info?.candidate_fit?.fit}`}
            </Typography>
            <IconButton
              onClick={() =>
                handleQuestionMarkClick(
                  chatBotData.geminiBubble &&
                    chatBotData.geminiBubble.length !== 0
                    ? chatBotData.geminiBubble.filter(
                        (item) => item.question === "Candidate fit"
                      )[0]
                    : chatBotData.bubble.filter(
                        (item) => item.question === "Candidate fit"
                      )[0]
                )
              }
              style={{ opacity: !iconVisible ? 0.5 : 1, padding: "0px" }}
              disabled={!iconVisible}
            >
              <CandidateFitIco />
            </IconButton>
          </CommonGrid2>
        )}
        {matchedData?.insights?.feedback?.red_flags?.length !== 0 && (
          <Fragment>
            {loading ? (
              <HandleSkeletion
                width="100%"
                height="30px"
                transform="scale(1)"
              />
            ) : (
              <Fragment>
                <CommonGrid2
                  borderRadius={"10px"}
                  padding={"1rem"}
                  background={"#F7F8F9"}
                  marginTop={"10px"}
                  gap={"1rem"}
                  display={"flex"}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    width={"100%"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      justifyContent={"space-between"}
                      flexWrap={"wrap"}
                    >
                      <CommonGrid2
                        display={"flex"}
                        alignItems={"center"}
                        gap={"10px"}
                      >
                        <CommonGrid2 display={"flex"} marginRight={"5px"}>
                      <RedFlagIco
                            color={
                        negative_flag.length === 0
                          ? "#7F56D9"
                          : !matchedData?.insights?.feedback?.is_red_flags_reviewed
                          ? "#FF4F6F"
                          : "#7F56D9"
                      }
                    />
                        </CommonGrid2>

                        <Typography variant="h5">
                          {"Profile Alerts !"}
                        </Typography>
                        {matchedData?.insights?.feedback
                          ?.is_red_flags_reviewed && (
                          <Typography
                            variant="subtitle3"
                            border={"1px solid #AAEFC6"}
                            backgroundColor={"#ECFDF3"}
                            color={"#067647"}
                            padding={"1px 10px"}
                            borderRadius={"50px"}
                            fontWeight={600}
                          >
                            Reviewed
                          </Typography>
                        )}
                      </CommonGrid2>

                      {negative_flag.length !== 0 && (
                        <CommonButton
                          value={"Review"}
                          variant="text"
                          gap="0px"
                          padding={"5px 15px"}
                          border={"#D0D5DD"}
                          background={"#fff"}
                          fontWeight={700}
                          onClick={handleReview}
                        />
                      )}
                    </CommonGrid2>
                    <CustomDiv margin={"1rem 0px 0px 2.5rem"}>
                      <CommonGrid2
                        display={"flex"}
                        size={12}
                        columnSpacing={"2rem"}
                        rowSpacing={"1rem"}
                        container
                      >
                        {matchedData?.insights?.feedback?.red_flags.map(
                          (item) => (
                            <CommonTippy
                              content={item.flag_text}
                              placement="top"
                              color="#7F56D9"
                              fontWeight={600}
                              fontSize={"13px"}
                            >
                              <CommonGrid2
                                item
                                display={"flex"}
                                gap={"10px"}
                                alignItems={"center"}
                                // size={{
                                //   xs: 12,
                                //   sm: 4,
                                //   md: checkWidth > 800 ? 3 : 4,
                                // }}
                              >
                                <CustomDiv display="flex">
                                  {item.type === "positive" ? (
                                    <AnomalyIco color={"#17B26A"} />
                                  ) : (
                                    <RedFlagNegativeIco
                                      color={
                                        !matchedData?.insights?.feedback
                                          ?.is_red_flags_reviewed && "#FF4F6F"
                                      }
                                    />
                                  )}
                                </CustomDiv>

                                <Typography
                                  variant="body4"
                                  style={{
                                    wordBreak: "break-word",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item.name}
                                </Typography>
                              </CommonGrid2>
                            </CommonTippy>
                          )
                        )}
                      </CommonGrid2>
                    </CustomDiv>
                  </CommonGrid2>
                </CommonGrid2>
              </Fragment>
            )}
          </Fragment>
        )}
      </CommonGrid2>
    </CommonGrid2>
  );
}
